module.exports = __webpack_public_path__ + "img/23.8e4f11ce.png";